import {management} from '../../../../index'

import {FarmsDapRepository} from '../../../infra/knex/repositories/farmsDapRepository'
import {CreateFarmsUseCase} from './createFarmsUseCase'


export const create=new CreateFarmsUseCase(new FarmsDapRepository(management))
